<template>
  <v-form @submit="onSubmit" :action="action" ref="form" method="get">
    <v-row justify="center">
      <v-col cols="12" sm="6" lg="4">
        <label
          for="business"
          class="primary--text text-h5 text-md-h4 text-lg-h3 font-weight-bold"
        >
          O que você precisa?
        </label>
        <v-select
          class="mt-2 rounded-lg white"
          v-model="businessModel"
          hide-details
          dense
          outlined
          :items="business"
          name="business"
          id="business"
          :height="sm ? `50px` : `60px`"
          required
        ></v-select>
      </v-col>

      <!-- <v-col cols="12" sm="6" lg="4" v-if="filterBusiness === 'Locação'">
        <label
          for="bedrooms"
          class="primary--text text-h5 text-md-h4 text-lg-h3 font-weight-bold"
        >
          Quantidade de Quartos:
        </label>
        <v-select
          class="mt-2 rounded-lg white"
          v-model="bedroomsModel"
          hide-details
          dense
          outlined
          :items="[
            { text: `Todos`, value: 0 },
            { text: 1, value: 1 },
            { text: 2, value: 2 },
            { text: 3, value: 3 },
            { text: 4, value: 4 },
            { text: 5, value: 5 },
            { text: 'mais que 5', value: '+5' },
          ]"
          name="bedrooms"
          id="bedrooms"
          :height="sm ? `50px` : `60px`"
          required
        ></v-select>
      </v-col> -->

      <!-- <v-col cols="12" sm="6" lg="4" v-if="filterBusiness === 'Venda'">
        <label
          for="types"
          class="primary--text text-h5 text-md-h4 text-lg-h3 font-weight-bold"
        >
          Tipo de Imóvel:
        </label>
        <v-select
          class="mt-2 rounded-lg white"
          v-model="typesModel"
          hide-details
          dense
          outlined
          :items="types"
          name="types"
          id="types"
          :height="sm ? `50px` : `60px`"
          required
        ></v-select>
      </v-col> -->
    </v-row>

    <div class="text-center">
      <v-btn
        color="primary darken-1"
        class="
          white--text
          px-16
          mt-8
          text-h5 text-lg-h4
          font-weight-medium
          text-none
          btn-contact
        "
        type="submit"
        rounded
        depressed
        height="48px"
      >
        Buscar
      </v-btn>
    </div>
  </v-form>
</template>

<script>
export default {
  data() {
    return {
      action: `/imoveis`,
      businessModel: this.$rest(`business`).list[1].id,
      bedroomsModel: 0,
      typesModel: 0,
      types: [{ text: "Todos", value: 0 }],
    };
  },
  computed: {
    business() {
      return this.$rest(`business`).list.map(({ id, title }) => ({
        text: title,
        value: id,
      }));
    },
    filterBusiness() {
      if (!this.business) return "";
      return this.business.filter(
        (item) => item.value === this.businessModel
      )[0].text;
    },
    sm() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    onSubmit(event) {
      const query = {};

      if (this.businessModel) query.finalidade = this.businessModel;
      if (this.bedroomsModel && this.filterBusiness === "Locação")
        query.quartos = this.bedroomsModel;
      if (this.typesModel && this.filterBusiness === "Venda")
        query.tipo = this.typesModel;

      this.$router.push(this.action);

      this.$router.push({ query });

      event.preventDefault();
    },
  },
  mounted() {
    this.$rest(`categories`)
      .get({ params: { type: "types" } })
      .then((data) => {
        this.types = [
          ...[{ text: "Todos", value: 0 }],
          ...data.map(({ id, title }) => ({
            text: title,
            value: id,
          })),
        ];
      });
  },
};
</script>

<style lang="scss">
.v-text-field {
  .v-input__append-inner {
    margin-bottom: auto !important;
    margin-top: auto !important;
  }
}
</style>
